<nwm-menu />
<div class="content">
  <div class="main">
    <a class="anchor" id="summary" aria-hidden="true"></a>
    <div class="row mb-5 mt-4">
      <div class="portfolio-details-table col-xxl-10 offset-xxl-1">
        <h1 class="mt-4 mb-3" style="margin-right: 120px">
          Portfolio Details <span class="as-of">As Of <VDPicker class="vd-picker portfolio" (dateChange)="onValuationDateChange()" /></span>
        </h1>
        <a tabindex="0" role="button" (click)="export()" class="export-btn d-print-none">Export</a>
        @if (data) {
          <div class="scrollable-wrap">
            <div class="scrollable">
              <div class="scrollable-button left"></div>
              <div class="scrollable-button"></div>
              <table width="100%" class="NWMtable sticky_header assetSummary">
                <ng-container *ngTemplateOutlet="thead" />
                <tbody>
                  @for (t of data; track t) {
                    <tr class="currency dblue-bg" [ngClass]="{'opened':t.opened, 'LessThanYear':t.isLessThanYear}" (click)="t.opened=!t.opened">
                      <td [attr.colspan]="t.opened?(showDWdetails?12:10):2" class="no-border text-left tooltip-msg" container="body" [ngbTooltip]="t.opened?null:accountsMsg"><b>{{t.other ? 'OTHER HOLDINGS ' : ''}} {{t.currency === 'USD' ? 'US' : 'CANADIAN'}} DOLLAR ACCOUNTS</b></td>
                      @if (!t.opened) {
                        <td class="no-border boyb-col">                       {{t.totals[0].BeginningOfYearBalance}}</td>
                        @if (showDWdetails) {
                          <td class="no-border dep-col">  {{t.totals[0].DepositsYTD}}</td>
                        }
                        @if (showDWdetails) {
                          <td class="no-border with-col"> {{t.totals[0].WithdrawalsYTD}}</td>
                        }
                        <td class="no-border net-dep-with-col">               {{t.totals[0].NetDepositsWithdrawalsYTD}}</td>
                        <td class="no-border current-market-value-col">       {{t.totals[0].CurrentMarketValue}}</td>
                        <td class="no-border gain-loss-year-col">             {{t.totals[0].GainLossForTheYear}}</td>
                        <td class="no-border ytd-return-col">                 {{t.totals[0].YearToDateReturn | minusSignToParens}}</td>
                        <td class="no-border gain-loss-inception-col">        {{t.totals[0].GainLossSinceInception}}</td>
                        <td class="no-border annualized-return-inception-col">
                          {{t.totals[0].AnnualizedReturnSinceInception | minusSignToParens}}<span class="ARSI-star" aria-hidden="true" [ngbTooltip]="'Funds are invested for less than one year. Displayed return uses YTD return formula, refer to the FAQ page.'" placement="top" container="body">* </span>
                        </td>
                        <td class="no-border performance-start-date-col">     {{t.totals[0].PerformanceStartDate | date}}</td>
                      }
                    </tr>
                    @for (account of t.accounts; track account) {
                      <tr class="owner" [ngClass]="{'d-none':!t.opened}">
                        <td [attr.colspan]="showDWdetails?12:10" class="text-left"><b>{{account.Owner}}</b></td>
                      </tr>
                      @for (plan of account.Plan; track plan) {
                        @if (plan.isActive !== 0) {
                          <tr [ngClass]="{'d-none':!t.opened, 'LessThanYear':plan.isLessThanYear}">
                            <td class="no-border"></td>
                            <td class="text-left">
                              <!-- <b>{{plan.Key}}</b> -->
                              @if (t.other) {
                                <span>{{plan.Key}}</span>
                              }
                              @if (!t.other) {
                                <a [routerLink]="'/welcome/' + t.currency + ' - ' + account.Owner + ' - ' + plan.Key" class="tooltip-msg" container="body" [ngbTooltip]="planMsg">{{plan.Key}}</a>
                              }
                            </td>
                            <td class="boyb-col">                       {{plan.Total_SUM_BeginningOfYearBalance | placeholder:'-'}}</td>
                            @if (showDWdetails) {
                              <td class="dep-col">  {{plan.Total_SUM_DepositsYTD | placeholder:'-'}}</td>
                            }
                            @if (showDWdetails) {
                              <td class="with-col"> {{plan.Total_SUM_WithdrawalsYTD | placeholder:'-'}}</td>
                            }
                            <td class="net-dep-with-col">               {{plan.Total_SUM_NetDepositsWithdrawalsYTD | placeholder:'-'}}</td>
                            <td class="current-market-value-col">       {{t.other ? plan.SUM_CurrentMarketValue : plan.Total_SUM_CurrentMarketValue | placeholder:'-'}}</td>
                            <td class="gain-loss-year-col">             {{plan.Total_SUM_GainLossForTheYear | placeholder:'-'}}</td>
                            <td class="ytd-return-col">                 {{plan.Total_SUM_YearToDateReturn | minusSignToParens}}</td>
                            <td class="gain-loss-inception-col">        {{plan.Total_SUM_GainLossSinceInception | placeholder:'-'}}</td>
                            <td class="annualized-return-inception-col">
                              {{plan.Total_SUM_AnnualizedReturnSinceInception | minusSignToParens}}<span class="ARSI-star" aria-hidden="true" [ngbTooltip]="'Funds are invested for less than one year. Displayed return uses YTD return formula, refer to the FAQ page.'" placement="top" container="body">* </span>
                            </td>
                            <td class="performance-start-date-col">     {{plan.Total_MIN_PerformanceStartDate | date}}</td>
                          </tr>
                        }
                      }
                    }
                    @for (total of t.totals; track total) {
                      <tr class="no-border" [ngClass]="{'grandTotal':total.grand_total,'totals':!total.grand_total, 'd-none':!t.opened && !total.grand_total, 'LessThanYear':total.isLessThanYear}">
                        <td colspan="2" class="text-left">{{ total.title }}</td>
                        <td class="boyb-col">                       {{total.BeginningOfYearBalance}}</td>
                        @if (showDWdetails) {
                          <td class="no-border dep-col"> {{total.DepositsYTD}}</td>
                        }
                        @if (showDWdetails) {
                          <td class="no-border with-col">{{total.WithdrawalsYTD}}</td>
                        }
                        <td class="net-dep-with-col">               {{total.NetDepositsWithdrawalsYTD}}</td>
                        <td class="current-market-value-col">       {{total.CurrentMarketValue}}</td>
                        <td class="gain-loss-year-col">             {{total.GainLossForTheYear}}</td>
                        <td class="ytd-return-col">                 {{total.YearToDateReturn | minusSignToParens}}</td>
                        <td class="gain-loss-inception-col">        {{total.GainLossSinceInception}}</td>
                        <td class="annualized-return-inception-col">
                          {{total.AnnualizedReturnSinceInception | minusSignToParens}}<span class="ARSI-star" aria-hidden="true" [ngbTooltip]="'Funds are invested for less than one year. Displayed return uses YTD return formula, refer to the FAQ page.'" placement="top" container="body">* </span>
                        </td>
                        <td class="performance-start-date-col">     {{total.PerformanceStartDate | date}}</td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
              <div class="sticky_header_clone" style="display:none">
                <table width="100%" class="NWMtable">
                  <ng-container *ngTemplateOutlet="thead" />
                </table>
              </div>
            </div>
          </div>
        }

        <ng-template #accountsMsg><span class="profile-tooltip">Click on the arrow to view accounts</span></ng-template>
        <ng-template #planMsg><span class="profile-tooltip">Click account name for more details</span></ng-template>

        <ng-template #thead>
          <thead>
            <tr>
              <td colspan="2" style="min-width:134px"></td>
              <td class="boyb-col">                       Beginning of Year<br>Market Value&nbsp;($)</td>
              @if (showDWdetails) {
                <td class="dep-col DWCol">Deposits<br />YTD&nbsp;($)</td>
              }
              @if (showDWdetails) {
                <td class="with-col DWCol">Withdrawals<br />YTD&nbsp;($)</td>
              }
              <td class="net-dep-with-col">               Net Deposits &<br>Withdrawals YTD&nbsp;($) <a href="javascript:void(0)" (click)="DWClick()">{{showDWdetails?'-':'+'}}</a></td>
              <td class="current-market-value-col">       Current<br />Market Value&nbsp;($)</td>
              <td class="gain-loss-year-col">             Gain/Loss<br />for the Year&nbsp;($)</td>
              <td class="ytd-return-col">                 YTD<br />Return</td>
              <td class="gain-loss-inception-col">        Gain/Loss<br />Since Inception&nbsp;($)</td>
              <td class="annualized-return-inception-col">Annualized Return<br />Since Inception</td>
              <td class="performance-start-date-col">     Performance<br />Start Date</td>
            </tr>
          </thead>
        </ng-template>
      </div>
    </div>
  </div>
</div>
